
/**
 * 工作流-变量设置节点
 * zxw
 * 创建时间 2026-05-11
 */

import CNF from '../../incs/Config';
import {
    winHeight,
} from '../../incs/FunHelper';
import { SysCall } from '../../incs/SysCall';
import { useState, useEffect, useRef, useCallback } from 'react';
import {
    ConfigProvider,
    Modal,
    Avatar,
    Space,
    Divider,
    Input,
    Select,
    Button,
    Typography,
    Row,
    Col,
    InputNumber,
    Tag,
    Cascader,
    Tooltip,
} from 'antd';
import {
    CheckOutlined,
    EditOutlined,
    PlusOutlined,
    DeleteOutlined,
    InfoCircleOutlined,
} from '@ant-design/icons';

const { Text, Paragraph } = Typography;

// ---------- 可拖拽宽度的常量配置 ----------
const MIN_MODAL_WIDTH = 480;   // 最小宽度
const MAX_MODAL_WIDTH = 680;   // 最大宽度

const VarsetNodeEntity = (props) => {
    const [open, setOpen] = useState(false);
    const [isEditTitle, setIsEditTitle] = useState(false);  // 标题是否编辑
    const [currentTitle, setCurrentTitle] = useState('');   // 当前标题

    const [variables, setVariables] = useState([]);       // 请求参数

    // ---------- 宽度拖拽部分 ---------- //
    const [modalWidth, setModalWidth] = useState(MIN_MODAL_WIDTH);
    const [dragIsHover, setDragIsHover] = useState(false);
    const widthRef = useRef(modalWidth);
    const draggingRef = useRef(false);
    const startXRef = useRef(0);
    const startWidthRef = useRef(0);

    // 同步 ref 与 state
    useEffect(() => {
        widthRef.current = modalWidth;
    }, [modalWidth]);

    // 弹窗打开时重置宽度为默认值
    useEffect(() => {
        if (open) {
            setModalWidth(MIN_MODAL_WIDTH);
        }
    }, [open]);

    const onMouseDown = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        draggingRef.current = true;
        startXRef.current = e.clientX;
        startWidthRef.current = widthRef.current;

        document.body.style.userSelect = 'none';
        document.body.style.cursor = 'col-resize';

        const onMouseMove = (moveEvent) => {
            if (!draggingRef.current) return;
            const delta = moveEvent.clientX - startXRef.current;
            let newWidth = startWidthRef.current - delta; // 左侧拖拽
            newWidth = Math.max(MIN_MODAL_WIDTH, Math.min(MAX_MODAL_WIDTH, newWidth));
            setModalWidth(newWidth);
        };

        const onMouseUp = () => {
            draggingRef.current = false;
            setDragIsHover(false);
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
            document.body.style.userSelect = '';
            document.body.style.cursor = '';
        };

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    }, []);

    const modalRender = (modal) => (
        <div style={{
            position: 'relative',
            width: '100%',
            height: '100%',
            overflow: 'visible',
            pointerEvents: 'auto',
        }}>
            {modal}
            {/* 左侧热区 */}
            <div
                onMouseDown={onMouseDown}
                onMouseEnter={() => setDragIsHover(true)}
                onMouseLeave={() => {
                    if (!draggingRef.current) setDragIsHover(false);
                }}
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: 8,
                    height: '100%',
                    zIndex: 10000,
                    cursor: 'col-resize',
                }}
            ></div>
            {/* 真实手柄 */}
            <div
                onMouseDown={onMouseDown}
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: 2,
                    height: '100%',
                    cursor: 'col-resize',
                    zIndex: 10000, // 确保在最上层
                    background: 'rgba(24, 144, 255, 0.1)',
                    borderLeft: '2px solid rgba(24, 144, 255, 0.3)',
                    transition: 'opacity 0.2s',
                    pointerEvents: 'none',
                    opacity: dragIsHover ? 1 : 0,
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(24, 144, 255, 0.3)'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(24, 144, 255, 0.1)'}
            />
        </div>
    );
    // ---------- 宽度拖拽部分 ---------- //

    const cancel = () => {
        setOpen(false);
        setIsEditTitle(false);
    }

    useEffect(() => {
        setOpen(props.open);

        setCurrentTitle(props.node.data?.title);

        // 初始化
        setVariables((props.node?.data?.input?.variables) ? props.node?.data?.input?.variables : []);
    }, [props]);

    useEffect(() => {
        let output = {};
        for (let i = 0; i < variables.length; i++) {
            let item = variables[i];
            if (item.name) {
                // 输出，并给出默认值
                output[item.name] = CNF.variableTypes.find(obj => obj.value === item.type)?.defaultValue;
            }
        }

        // 更新输出
        props.node.setData({
            ...(delete props.node.data?.output, props.node.data),
            output: output,
        });
    }, [variables]);

    return (
        <ConfigProvider theme={{
            token: {
                colorPrimary: global.THEMECOLOR,
            },
        }}>
            <Modal
                title={
                    <Space>
                        <Avatar size='small' shape='square' icon={props.node.data?.icon} style={{ background: props.node.data?.theme, }} />
                        {
                            isEditTitle ? <Input
                                value={currentTitle}
                                onChange={(e) => {
                                    setCurrentTitle(e.target.value);
                                }}
                            /> : props.node.data?.title
                        }
                        {
                            isEditTitle ?
                                <Button color='primary' variant='link' icon={<CheckOutlined />} onClick={() => {
                                    props.node.setData({
                                        ...props.node.data,
                                        title: currentTitle,
                                    });
                                    setIsEditTitle(false);
                                }} />
                                :
                                <Button color='primary' variant='link' icon={<EditOutlined />} onClick={() => {
                                    setIsEditTitle(true);
                                }} />
                        }
                    </Space>
                }
                width={modalWidth}           // 使用动态宽度
                modalRender={modalRender}    // 注入拖拽手柄
                height={winHeight - CNF.menuHeight - CNF.basePadding * 2}
                style={{
                    top: CNF.menuHeight + CNF.basePadding,
                    right: 18,
                    position: 'absolute',
                    scrollbarWidth: 'thin',
                    overflowY: 'auto',
                    paddingRight: 1,
                }}
                mask={{
                    enabled: false,
                    closable: true,
                }}
                open={open}
                onCancel={cancel}
                footer={null}
            >
                <Divider style={{ marginLeft: '-25px', marginRight: '-25px', width: 'calc(100% + 50px)', }} />
                <Paragraph>
                    <Space><Text>变量设置</Text><Tooltip title='自定义变量设置并赋值'><InfoCircleOutlined style={{ color: props.colorBasePlaceholder }} /></Tooltip></Space>
                </Paragraph>
                <Row>
                    <Col span={6}>变量名</Col>
                    <Col span={4}>引用方式</Col>
                    <Col span={14}>值</Col>
                </Row>
                {
                    variables && variables.map((item, index) => {
                        // 通用更新函数：更新指定索引的字段
                        const updateParams = (updates) => {
                            setVariables(prev => {
                                const updated = prev.map((p, i) =>
                                    i === index ? { ...p, ...updates } : p
                                );
                                props.node.setData({
                                    ...props.node.data,
                                    input: { variables: updated },
                                });
                                return updated;
                            });
                        };

                        // 获取Cascader值
                        const getCascaderValue = (value) => {
                            if (value) {
                                return [props.graph.getNodes().find(node => node.getZIndex().toString() === value.split('/')[0])?.data.title, value];
                            } else {
                                return [];
                            }
                        };

                        // 根据变量类型返回对应组件
                        const getVariableComponent = (type) => {
                            if (type === 'string') {
                                return <Input
                                    placeholder='请输入变量值'
                                    style={{ width: '100%' }}
                                    value={item.value}
                                    onChange={(e) => updateParams({ value: e.target.value })}
                                />
                            } else if (type === 'number') {
                                return <InputNumber
                                    placeholder='请输入变量值'
                                    style={{ width: '100%' }}
                                    value={item.value}
                                    onChange={(value) => updateParams({ value: value })}
                                />
                            }
                        };

                        return <Row key={index} style={{ marginTop: 5, }}>
                            <Col span={6} style={{ paddingRight: 8, }}>
                                <Input
                                    placeholder='请输入变量名'
                                    size='small'
                                    value={item.name}
                                    onChange={(e) => updateParams({ name: e.target.value })}
                                />
                            </Col>
                            <Col span={4} style={{ paddingRight: 8, }}>
                                <Select
                                    style={{ width: '100%' }}
                                    size='small'
                                    options={CNF.referenceMethods.map(item => {
                                        return {
                                            label: item,
                                            value: item,
                                        }
                                    })}
                                    value={item.referenceMethod}
                                    onChange={(value) => updateParams({ referenceMethod: value, value: '' })}
                                />
                            </Col>
                            <Col span={13}>
                                {
                                    item.referenceMethod === '输入' ? (
                                        <Space.Compact size='small' block>
                                            <Select
                                                popupMatchSelectWidth={false}
                                                options={CNF.variableTypes.map(item => {
                                                    return {
                                                        label: item.name,
                                                        value: item.value,
                                                    }
                                                })}
                                                value={item.type}
                                                onChange={(value) => updateParams({ type: value })}
                                            />
                                            {
                                                getVariableComponent(item.type)
                                            }
                                        </Space.Compact>
                                    ) : (
                                        item.referenceMethod === '引用' ? (
                                            <Cascader
                                                placeholder='请选择变量'
                                                size='small'
                                                style={{ width: '100%' }}
                                                suffixIcon={item.referenceMethod === '引用' && item.value ? `[${item.type}]` : ''}
                                                options={props.graph && props.graph.getNodes()
                                                    .filter(node => !(node.data?.key === 'End' || node.getZIndex() >= props.node.getZIndex()))
                                                    .map((node) => {
                                                        return {
                                                            label: <Space><Avatar size={16} shape='square' icon={node.data.icon} style={{ background: node.data.theme, }} />{node.data.title}</Space>,
                                                            value: node.data.title,
                                                            children: Object.keys(node.data?.key === 'Start' ? node.data?.input.sys : node.data?.output).map((item) => {
                                                                const path = node.getZIndex().toString() + (node.data?.key === 'Start' ? '/input/sys/' : '/output/') + item;
                                                                return {
                                                                    label: <Text ellipsis>{item}</Text>,
                                                                    value: path,
                                                                }
                                                            }),
                                                        }
                                                    })}
                                                value={getCascaderValue(item.value)}
                                                onChange={(value) => updateParams({ value: value && value.length > 0 ? value[1] : '' })}
                                            />
                                        ) : (
                                            <Select
                                                size='small'
                                                showSearch
                                                allowClear
                                                style={{ width: '100%' }}
                                                placeholder='请选择系统调用方法'
                                                options={SysCall.methods.map(item => {
                                                    return {
                                                        label: <Tooltip title={<>
                                                            <div>名称：{item.name}</div>
                                                            <div>说明：{item.description}</div>
                                                        </>}>{item.name}</Tooltip>,
                                                        value: item.value,
                                                        type: item.returnType
                                                    }
                                                })}
                                                filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                                                value={item.value ? item.value : undefined}
                                                onChange={(value, option) => updateParams({ value: value, type: option.type })}
                                            />
                                        )
                                    )

                                }
                            </Col>
                            <Col span={1}>
                                <Button
                                    size='small'
                                    color='primary'
                                    variant='link'
                                    icon={<DeleteOutlined />}
                                    onClick={() => {
                                        const delVariables = variables.filter((_, i) => i !== index);
                                        setVariables(delVariables);
                                        props.node.setData({
                                            ...props.node.data,
                                            input: {
                                                ...(delete props.node.data.input?.variables, props.node.data.input),
                                                variables: delVariables,
                                            },
                                        });
                                    }}
                                />
                            </Col>
                        </Row>
                    })
                }

                <Button size='small' color='primary' variant='link' icon={<PlusOutlined />} style={{ padding: 0 }} onClick={() => {
                    setVariables([...variables, {
                        name: '',
                        value: '',
                        type: CNF.variableTypes[0].value,
                        referenceMethod: CNF.referenceMethods[0],
                    }]);
                }}>添加变量</Button>
                <Divider style={{ marginLeft: '-25px', marginRight: '-25px', width: 'calc(100% + 50px)', }} />
                <Paragraph>
                    <Text>输出</Text>
                    {
                        variables && variables.map((item, index) => {
                            return <div key={index}><Space><Text>{item.name}</Text><Tag size='small' style={{ color: props.colorBasePlaceholder }}>{item.type}</Tag></Space></div>
                        })
                    }
                </Paragraph>
            </Modal>
        </ConfigProvider >
    );
}

export default VarsetNodeEntity;